import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationService} from '../../../@services/notification.service';
import {LocalstorageService} from '../../../@services/localstorage.service';
import {Staff, StaffProfileControllerService} from "../../../@services/gen";

@Component({
  selector: 'app-staff-editor-dialog',
  templateUrl: './staff-editor-dialog.component.html',
  styleUrls: ['./staff-editor-dialog.component.scss'],
})
export class StaffEditorDialogComponent {
  staff: Staff = {};
  title = 'Add New Staff';
  loading: boolean;

  constructor(
    private dialogRef: MatDialogRef<StaffEditorDialogComponent>,
    private staffService: StaffProfileControllerService,
    private ns: NotificationService,
    private ls: LocalstorageService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.staff = data.staff;
  }

  submit() {
    this.loading = true;
    this.staffService.upsertStaffProfilePost({
        staff: {...this.staff, merchant: {id: this.ls.getMerchant().id}} as any,
      })
      .subscribe(
        (staff) => {
          this.ns.showNotification(
            {message: 'Successfully added staff!'});
          this.loading = false;
          this.dialogRef.close(staff);
        },
        (error) => {
          this.ns.showNotification({message: 'Error while adding the staff'});
          this.loading = false;
        }
      );
  }
}
